<template>
    <div class="modal fade dialogbox" id="passphraseInfo" data-bs-backdrop="static" tabindex="-1"
         role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">

                <!-- Icon -->
                <div class="modal-icon">
                    <ion-icon name="lock-closed-outline"></ion-icon>
                </div>

                <!-- Title -->
                <div class="modal-header">
                    <h5 class="modal-title" v-if="loading">
                        <i>Fetching recovery phrase…</i>
                    </h5>
                    <h5 class="modal-title" v-else>Your recovery phrase</h5>
                </div>

                <!-- Body -->
                <div class="modal-body">
                    <template v-if="loading">
                        <div class="phrase-spinner">
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </template>
                    <template v-else-if="error">
                        <p class="phrase-error">{{message}}</p>
                        <p class="phrase-hint">
                            Navigate to Settings to recover your passphrase — it will be sent to your registered email address.
                        </p>
                        <button class="btn phrase-retry-btn" @click.prevent="initPassPhrase">
                            <ion-icon name="reload-circle-outline"></ion-icon> Try again
                        </button>
                    </template>
                    <template v-else>
                        <p class="phrase-instruction">
                            Write down or copy these words in the right order and save them somewhere safe.
                        </p>
                        <div class="phrase-grid">
                            <span class="phrase-word" v-for="(phrase, idx) in phrases" :key="idx">
                                <span class="phrase-num">{{idx + 1}}</span>{{phrase}}
                            </span>
                        </div>
                    </template>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <div class="btn-inline" v-if="!loading && !error">
                        <a @click="copyPassPhrase" href="javascript:void(0)" class="btn phrase-copy-btn">
                            <ion-icon name="copy-outline"></ion-icon> Copy
                        </a>
                        <a href="javascript:void(0)" class="btn phrase-continue-btn" data-bs-dismiss="modal">Continue</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'passPhraseInfo',
    data(){
        return {
            loading: true,
            message: "",
            error: false,
            phrases: []
        }
    },
    methods: {
        copyPassPhrase(){
            navigator.clipboard.writeText(this.phrases.join(','));
            return this.$store.dispatch('notification/display_noti', {
                message: 'copied to clipboard!',
                timeout: 1000
            })
        },
        async initPassPhrase(){
            this.loading = true;
            this.phrases = this.$globalFunc.passPhrase;
            const response = await this.$store.dispatch('user/updateUser', {
                userId: this.$store.getters['user/getUser'].id,
                userData: {pass_phrase: this.phrases}
            });
            if(!response.status){
                this.error = true;
                this.message = "Unable to fetch wallet passphrase"
            }else{
                this.error = false;
            }
            this.loading = false;
        }
    },
    mounted() {
        const modal = $('#passphraseInfo');
        modal.on('hidden.bs.modal', ()=>{
            this.$emit('closed')
        });
        modal.on('shown.bs.modal', ()=>{
            this.initPassPhrase();
        })
    }
};
</script>

<style scoped>
/* Icon — theme sizes via font-size on the parent, we just recolour */
.modal-icon {
    color: var(--theme-primary-500, #73614C) !important;
}

/* Title */
.modal-title {
    font-size: 18px;
    font-weight: 700;
    color: #1A0F08;
}

/* Instruction text */
.phrase-instruction {
    font-size: 13px;
    color: #73614C;
    margin-bottom: 16px;
    line-height: 1.6;
}

/* Phrase grid */
.phrase-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-top: 4px;
}
.phrase-word {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #F5EDE4;
    border: 1px solid rgba(115,97,76,0.25);
    color: #2A1F13;
    font-size: 13px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 50px;
}
.phrase-num {
    font-size: 10px;
    font-weight: 700;
    color: #73614C;
    opacity: 0.7;
    min-width: 14px;
}

/* Spinner */
.phrase-spinner {
    display: flex;
    justify-content: center;
    padding: 24px 0;
}
.phrase-spinner .spinner-border {
    color: var(--theme-primary-500, #73614C);
    width: 32px;
    height: 32px;
}

/* Error state */
.phrase-error {
    color: #C0392B;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 8px;
}
.phrase-hint {
    font-size: 13px;
    color: #888;
    line-height: 1.6;
    margin-bottom: 12px;
}
.phrase-retry-btn {
    color: var(--theme-primary-500, #73614C);
    border: 1.5px solid var(--theme-primary-500, #73614C);
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
    padding: 8px 20px;
}

/* Footer buttons */
.phrase-copy-btn {
    background: var(--theme-primary-500, #73614C) !important;
    color: #fff !important;
    border-radius: 50px !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 6px !important;
    padding: 10px 28px !important;
}
.phrase-copy-btn ion-icon {
    font-size: 16px;
}
.phrase-continue-btn {
    color: #2A1F13 !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    border-radius: 50px !important;
    padding: 10px 28px !important;
}
</style>